import z from "zod";

declare global {
  interface Window {
    __keyCaptureListenerInit?: boolean;
  }
}

/**
 * Type declarations for the Keyboard Layout API (not yet in standard TypeScript lib)
 * @see https://wicg.github.io/keyboard-map/
 */
export interface NavigatorWithKeyboard extends Navigator {
  keyboard?: {
    getLayoutMap(): Promise<KeyboardLayoutMap>;
  };
}

export interface KeyboardLayoutMap {
  get(code: string): string | undefined;
}

/**
 * Represents a captured key combination using physical key codes.
 * Uses `code` (physical key position) rather than `key` (character produced)
 * for keyboard-layout independence.
 */
export const KeyCombination = z.object({
  /** The physical key code (e.g., "KeyA", "Digit1", "Space") - layout independent */
  code: z.string(),
  /** Original key value for reference (layout-dependent, may vary with modifiers) */
  key: z.string(),
  /**
   * The base key-cap character for the physical key on the current keyboard layout.
   * Retrieved via Keyboard Layout API when available. This is what's printed on the key-cap
   * without any modifiers applied. e.g., on Dvorak, KeyD → "E".
   */
  keyCap: z.string(),
  ctrlKey: z.boolean(),
  shiftKey: z.boolean(),
  altKey: z.boolean(),
  metaKey: z.boolean(),
});

export type KeyCombination = z.infer<typeof KeyCombination>;
